import { commonV2URL, commonV3URL } from 'src/constantsMessage';
import axios from 'src/utils/axiosHelper';
import helperAxios from 'src/utils/helperAxios';

export const OPEN_PDF = '@open-pdf';
export const EMPTY_PDFVIEW = '@empty-pdfview';
export const GET_FILEPATH = '@get-filePath';
export const GET_FILEPATH_ERROR = '@get-filePath-error';
export const GET_FILE_DATA = '@get-fileData';
export const GET_FILE_DATA_ERROR = '@get-fileData-error';

export function openPdf(file, password) {
  return dispatch => {
    dispatch({
      type: OPEN_PDF,
      payload: file,
      payload1: password
    });
  };
}

export function emptyPdf() {
  return dispatch => {
    dispatch({
      type: EMPTY_PDFVIEW
    });
  };
}

export function getFilePath(fileId, password) {
  const url = `${commonV2URL}/file/source?fileId=${fileId}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_FILEPATH,
          payload: response.data,
          payload1: password
        })
      )
      .catch(error => {
        dispatch({
          type: GET_FILEPATH_ERROR,
          payload: error.response && error.response.data
        });
      });
  };
}

export function getFileDownload(fileId) {
  const url = `${commonV3URL}/file/download?fileId=${fileId}`;
  const request = helperAxios(url, 'get', null, null, 'arraybuffer');

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_FILE_DATA,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_FILE_DATA_ERROR,
          payload: error.response && error.response.data
        });
      });
  };
}

export function getFileDownloadEmpty() {
  return dispatch => {
    dispatch({
      type: GET_FILE_DATA,
      payload: null
    });
  };
}
